<template>
  <div class="index" v-cloak>
    <div class="header acea-row row-center-wrapper" style="overflow: visible;">
      <!-- <div class="logo"><img :src="logoUrl" /></div>
      <router-link :to="'/search'" class="search acea-row row-middle">
        <span class="iconfont icon-xiazai5"></span>搜索商品
      </router-link> -->
      <div class="location" @click="linkToLocation">
        <img src="@assets/images/location.png" alt="" />
        <div class="location-address" v-show="locationAddressPopupShow">
          <img
            class="location-icon"
            src="@assets/images/dingwei-white.png"
            alt=""
          />
          <span>{{ location.addrInfo.name || "地址获取中..." }}</span>
        </div>
      </div>
      <router-link :to="'/search'" class="search acea-row row-middle">
        <span class="iconfont icon-xiazai5"></span>搜索商品
      </router-link>
    </div>
    <div class="slider-banner banner">
      <swiper :options="swiperOption" v-if="banner.length > 0">
        <swiper-slide v-for="(item, index) in banner" :key="index">
          <a
            class="search acea-row row-middle"
            :href="item.jump_url"
            v-if="item.jump_type == 3"
          >
            <img :src="item.pic" />
          </a>
          <router-link
            v-else
            :to="item.jump_type == 2 ? { path: '/detail/' + item.jump_id } : ''"
            class="search acea-row row-middle"
          >
            <img :src="item.pic" />
          </router-link>
        </swiper-slide>
        <div class="swiper-pagination paginationBanner" slot="pagination"></div>
      </swiper>
    </div>
    <!-- <div class="nav acea-row">
      <router-link
        :to="item.wap_url ? item.wap_url : ''"
        class="item"
        v-for="(item, index) in menus"
        :key="index"
      >
        <div class="pictrue"><img :src="item.pic" /></div>
        <div>{{ item.name }}</div>
      </router-link>
    </div> -->
    <div class="nav acea-row" v-if="category[0] && category[0].children">
      <div
        @click="handleNavLink(child)"
        class="item"
        v-for="(child, index) in category[0].children"
        :key="index"
      >
        <div class="pictrue"><img :src="child.pic" /></div>
        <div>{{ child.cate_name }}</div>
      </div>
    </div>

    <div class="productList">
      <div
        class="list acea-row row-between-wrapper"
        style="margin-top: 0;"
        :class="Switch === true ? '' : 'on'"
        ref="container"
      >
        <router-link
          :to="{
            path: '/detail/' + item.id
          }"
          class="item"
          :class="Switch === true ? '' : 'on'"
          v-for="(item, index) in productList"
          :key="index"
          :title="item.store_name"
        >
          <div class="pictrue" :class="Switch === true ? '' : 'on'">
            <img :src="item.image" :class="Switch === true ? '' : 'on'" />
          </div>
          <div class="text" :class="Switch === true ? '' : 'on'">
            <div class="name line1">{{ item.store_name }}</div>
            <div class="money c-brand" :class="Switch === true ? '' : 'on'">
              ￥<span class="num">{{ item.price }}</span>
            </div>
            <div
              class="vip acea-row row-between-wrapper"
              :class="Switch === true ? '' : 'on'"
            >
              <div
                class="vip-money"
                v-if="item.vip_price && item.vip_price > 0"
              >
                ￥{{ item.vip_price }}<img src="@assets/images/vip.png" />
              </div>
              <div>已售{{ item.sales }}件</div>
            </div>
          </div>
        </router-link>
      </div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
    <!-- <div class="news acea-row row-between-wrapper">
      <div class="pictrue"><img src="@assets/images/news.png" /></div>
      <div class="swiper-no-swiping new-banner">
        <swiper
          class="swiper-wrapper"
          :options="swiperRoll"
          v-if="roll.length > 0"
        >
          <swiper-slide
            class="swiper-slide"
            v-for="(item, index) in roll"
            :key="index"
          >
            <router-link
              :to="item.wap_url ? item.wap_url : ''"
              class="acea-row row-between-wrapper"
            >
              <div class="text acea-row row-between-wrapper">
                <div class="label" v-if="item.show === '是'">最新</div>
                <div class="newsTitle line1">{{ item.info }}</div>
              </div>
              <div class="iconfont icon-xiangyou"></div>
            </router-link>
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <div
      class="specialArea acea-row row-between-wrapper"
      v-if="activityOne.wap_link !== undefined || activity.length"
    >
      <router-link
        :to="activityOne.wap_link ? activityOne.wap_link : ''"
        v-if="activityOne.wap_link !== undefined"
        class="assemble"
      >
        <img :src="activityOne.pic" />
        <div class="text">
          <div class="name">{{ activityOne.title }}</div>
          <div class="infor">{{ activityOne.info }}</div>
        </div>
      </router-link>
      <div class="list acea-row row-column-between">
        <router-link
          :to="item.wap_link ? item.wap_link : ''"
          class="item"
          v-for="(item, index) in activity"
          :key="index"
        >
          <img :src="item.pic" />
          <div class="text">
            <div class="name">{{ item.title }}</div>
            <div class="infor">{{ item.info }}</div>
          </div>
        </router-link>
      </div>
    </div> -->
    <!-- <div class="wrapper" v-if="info.fastList.length > 0">
    <div class="title acea-row row-between-wrapper">
      <div class="text">
        <div class="name line1">快速选择</div>
        <div class="line1">{{ info.fastInfo }}</div>
      </div>
      <router-link :to="'/category'" class="more"
        >更多<span class="iconfont icon-jiantou"></span
      ></router-link>
    </div>
    <div class="scroll-product">
      <swiper class="swiper-wrapper" :options="swiperScroll">
        <swiper-slide
          v-for="(item, index) in info.fastList"
          :key="index"
          class="swiper-slide"
        >
          <router-link
            :to="{
              path: '/goods_list',
              query: { id: item.id, title: item.cate_name }
            }"
          >
            <div class="img-box">
              <img :src="item.pic" />
            </div>
            <div class="pro-info line1">{{ item.cate_name }}</div>
          </router-link>
        </swiper-slide>
      </swiper>
    </div>
    </div> -->
    <!-- <div
      class="wrapper"
      v-if="info.bastList.length > 0 || info.bastBanner.length > 0"
    >
      <div class="title acea-row row-between-wrapper">
        <div class="text">
          <div class="name line1">精品推荐</div>
          <div class="line1">{{ info.bastInfo }}</div>
        </div>
        <router-link :to="{ path: '/hot_new_goods/' + 1 }" class="more"
          >更多<span class="iconfont icon-jiantou"></span
        ></router-link>
      </div>
      <div class="slider-banner boutique" v-if="info.bastBanner.length > 0">
        <swiper class="swiper-wrapper" :options="swiperBoutique">
          <swiper-slide
            class="swiper-slide"
            v-for="(item, index) in info.bastBanner"
            :key="index"
          >
            <router-link :to="item.wap_link ? item.wap_link : ''"
              ><img :src="item.img"
            /></router-link>
          </swiper-slide>
        </swiper>
        <div class="swiper-pagination paginationBoutique"></div>
      </div>
      <Good-list :good-list="info.bastList" :is-sort="false"></Good-list>
    </div> -->
    <!-- <div class="hotList" v-if="likeInfo.length > 0">
      <div class="hot-bg">
        <div class="title acea-row row-between-wrapper">
          <div class="text line1">
            <span class="label">热门榜单</span>根据销量、搜索、好评等综合得出
          </div>
          <router-link :to="{ path: '/hot_new_goods/' + 2 }" class="more">
            更多<span class="iconfont icon-jiantou"></span>
          </router-link>
        </div>
      </div>
      <div class="list acea-row row-middle">
        <router-link
          :to="{ path: '/detail/' + item.id }"
          class="item"
          v-for="(item, index) in likeInfo"
          :key="index"
        >
          <div class="pictrue">
            <img :src="item.image" />
            <img
              src="@assets/images/one.png"
              class="numPic"
              v-if="index === 0"
            />
            <img
              src="@assets/images/two.png"
              class="numPic"
              v-else-if="index === 1"
            />
            <img
              src="@assets/images/three.png"
              class="numPic"
              v-else-if="index === 2"
            />
          </div>
          <div class="name line1">{{ item.store_name }}</div>
          <div class="money c-brand">
            ￥<span class="num">{{ item.price }}</span>
          </div>
        </router-link>
      </div>
    </div>
    <div v-if="lovely.img">
      <div class="adver">
        <img :src="lovely.img" />
      </div>
    </div>
    <div class="wrapper" v-if="info.firstList.length > 0">
      <div class="title acea-row row-between-wrapper">
        <div class="text">
          <div class="name line1">
            首发新品<span class="new c-brand">NEW~</span>
          </div>
          <div class="line1">{{ info.firstInfo }}</div>
        </div>
        <router-link :to="{ path: '/hot_new_goods/' + 3 }" class="more"
          >更多<span class="iconfont icon-jiantou"></span
        ></router-link>
      </div>
      <div class="newProducts">
        <swiper class="swiper-wrapper" :options="swiperProducts">
          <swiper-slide
            class="swiper-slide"
            v-for="(item, index) in info.firstList"
            :key="index"
          >
            <router-link :to="{ path: '/detail/' + item.id }">
              <div class="img-box">
                <img :src="item.image" />
              </div>
              <div class="pro-info line1">{{ item.store_name }}</div>
              <div class="money c-brand">￥{{ item.price }}</div>
            </router-link>
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <div class="wrapper" v-if="benefit.length > 0">
      <div class="title acea-row row-between-wrapper">
        <div class="text">
          <div class="name line1">促销单品</div>
          <div class="line1">{{ info.salesInfo }}</div>
        </div>
        <router-link :to="'/promotion'" class="more"
          >更多<span class="iconfont icon-jiantou"></span
        ></router-link>
      </div>
    </div>
    <Promotion-good :benefit="benefit"></Promotion-good>
    <Coupon-window
      :coupon-list="couponList"
      v-if="showCoupon"
      @checked="couponClose"
      @close="couponClose"
    ></Coupon-window>
    <div style="height:1.2rem;"></div>-->
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";
// import GoodList from "@components/GoodList";
// import PromotionGood from "@components/PromotionGood";
// import CouponWindow from "@components/CouponWindow";
import { getHomeData, getShare } from "@api/public";
import { getCategory } from "@api/store";
import { getProducts } from "@api/store";
import cookie from "@utils/store/cookie";
import { openShareAll } from "@libs/wechat";
import { isWeixin } from "@utils/index";
import Loading from "@components/Loading";
import mapService from "@libs/mapService";

const HAS_COUPON_WINDOW = "has_coupon_window";

export default {
  name: "Index",
  components: {
    swiper,
    swiperSlide,
    Loading
    // GoodList,
    // PromotionGood,
    // CouponWindow
  },
  props: {},
  data: function() {
    return {
      showCoupon: false,
      logoUrl: "",
      banner: [],
      menus: [],
      roll: [],
      activity: [],
      activityOne: {},
      info: {
        fastList: [],
        bastBanner: [],
        firstList: [],
        bastList: []
      },
      likeInfo: [],
      lovely: [],
      benefit: [],
      couponList: [],
      swiperOption: {
        pagination: {
          el: ".paginationBanner",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperRoll: {
        direction: "vertical",
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperScroll: {
        freeMode: true,
        freeModeMomentum: false,
        slidesPerView: "auto",
        observer: true,
        observeParents: true
      },
      swiperBoutique: {
        pagination: {
          el: ".paginationBoutique",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperProducts: {
        freeMode: true,
        freeModeMomentum: false,
        slidesPerView: "auto",
        observer: true,
        observeParents: true
      },

      category: [],
      Switch: true,
      where: {
        page: 1,
        limit: 999,
        keyword: "",
        sid: 0, //二级分类id
        news: 0,
        priceOrder: "",
        salesOrder: ""
      },
      loading: false,
      locationFail: false,
      locationAddressPopupShow: true
    };
  },
  mounted: function() {
    let that = this;
    getHomeData().then(res => {
      that.logoUrl = res.data.logoUrl;
      that.$set(that, "banner", res.data.banner);
      that.$set(that, "menus", res.data.menus);
      that.$set(that, "roll", res.data.roll);
      that.$set(that, "activity", res.data.activity);
      if (res.data.activity.length) {
        var activityOne = res.data.activity.shift();
        that.$set(that, "activityOne", activityOne);
      }
      that.$set(that, "info", res.data.info);
      that.$set(that, "likeInfo", res.data.likeInfo);
      that.$set(
        that,
        "lovely",
        res.data.lovely.length ? res.data.lovely[0] : {}
      );
      that.$set(that, "benefit", res.data.benefit);
      that.$set(that, "couponList", res.data.couponList);
      that.setOpenShare();
      this.showCoupon =
        !cookie.has(HAS_COUPON_WINDOW) &&
        res.data.couponList.some(coupon => coupon.is_use);
    });
    this.loadCategoryData();
    this.getProducts();
    if (this.$store.state.app.token) {
      this.getLocation();
    }
    window.addEventListener("scroll", () => {
      if (
        this.locationAddressPopupShow &&
        this.location.addrInfo &&
        this.location.addrInfo.name
      )
        this.locationAddressPopupShow = false;
    });
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.locationAddressPopupShow = true;
    });
  },

  computed: {
    location() {
      return this.$store.state.app.location;
    }
  },
  methods: {
    handleNavLink(cat) {
      if (cat.cate_name && cat.cate_name.indexOf("充值") !== -1) {
        return (window.location.href =
          "http://recharge.datongdiy.com/web/?time=202005#/");
      }
      if (cat.id === 53) {
        this.$router.push({
          path: "/article_list",
          query: { id: cat.id, title: cat.cate_name }
        });
        return;
      }
      this.$router.push({
        path: "/goods_list",
        query: { id: cat.id, title: cat.cate_name }
      });
    },
    linkToLocation() {
      this.$router.push({ path: "/location" });
    },
    getLocation() {
      mapService
        .getLocation()
        .then(res => {
          const latLng = { latitude: res.latitude, longitude: res.longitude };
          this.$store.commit("UPDATE_LOCATION", {
            latLng
          });
          return mapService.reverseGeocoder(latLng, 1);
        })
        .then(res => {
          let pois = res.regeocode.pois || [];
          pois = pois.slice(0, 4);
          const addressComponent = res.regeocode.addressComponent;
          const cityname =
            typeof addressComponent.city === "string"
              ? addressComponent.city
              : addressComponent.province;
          pois.forEach(item => {
            item.cityname = cityname;
          });
          const addrInfo = pois[0] || {};
          this.locationFail = false;
          this.$store.commit("UPDATE_LOCATION", {
            addrInfo,
            pois
          });
          console.log(res, "reverseGeocoder");
        })
        .catch(e => {
          this.locationFail = true;
          console.error(e);
        });
    },

    loadCategoryData() {
      getCategory().then(res => {
        const category = res.data;
        category[0] &&
          category[0].children &&
          category[0].children.length > 10 &&
          category[0].children.splice(10);
        this.category = category;
      });
    },
    getProducts() {
      this.loading = true;
      getProducts(this.where)
        .then(res => {
          this.productList = res.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    couponClose() {
      cookie.set(HAS_COUPON_WINDOW, 1);
    },
    setOpenShare: function() {
      if (isWeixin()) {
        getShare().then(res => {
          var data = res.data.data;
          var configAppMessage = {
            desc: data.synopsis,
            title: data.title,
            link: location.href,
            imgUrl: data.img
          };
          openShareAll(configAppMessage);
        });
      }
    }
  }
};
</script>
<style scoped>
.index {
  background-color: #fff;
}
.location {
  box-sizing: content-box;
  width: 0.4rem;
  height: 0.4rem;
  padding: 0.1rem;
  margin-right: 0.2rem;
  position: relative;
  overflow: visible;
}
.location .location-address {
  position: absolute;
  left: 0;
  top: 0.6rem;
  z-index: 999;
  padding: 0.04rem 0.08rem;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-size: 0.24rem;
  border-radius: 0.06rem;
  white-space: nowrap;
}
.location-address::before {
  box-sizing: border-box;
  content: " ";
  display: inline-block;
  width: 0;
  height: 0;
  border: 0.08rem solid transparent;
  border-bottom: 0.08rem solid rgba(0, 0, 0, 0.6);
  position: absolute;
  left: 0.2rem;
  top: -0.16rem;
  z-index: 1;
}
.location-address .location-icon {
  width: 0.2rem;
  height: 0.2rem;
  flex: 0 0 auto;
  margin-right: 0.06rem;
}
.location:active {
  opacity: 0.6;
}
.location img {
  width: 100%;
  height: 100%;
}
</style>
